export var FinishType;
(function (FinishType) {
  FinishType[FinishType["metallic"] = 0] = "metallic";
  FinishType[FinishType["raisedInk"] = 1] = "raisedInk";
  FinishType[FinishType["raisedFoilGold"] = 2] = "raisedFoilGold";
  FinishType[FinishType["raisedFoilSilver"] = 3] = "raisedFoilSilver";
  FinishType[FinishType["glitter"] = 4] = "glitter";
})(FinishType || (FinishType = {}));